const e = { helptextDropdownButton: { default: "Les mer <span class='pkt-sr-only'>om feltet</span>" }, counter: { default: !1 }, optionalTag: { default: !1 }, optionalText: { default: "Valgfritt" }, requiredTag: { default: !1 }, requiredText: { default: "Må fylles ut" }, hasError: { default: !1 }, disabled: { default: !1 }, inline: { default: !1 }, hasFieldset: { default: !1 }, useWrapper: { default: !0 } }, a = {
  props: e
};
export {
  a as s
};
